import React from 'react';
import { PanelMenu } from 'primereact/panelmenu';

const ClientesSidebar = ({ onOptionChange }) => {
    const items = [
        {
            label: 'Criar',
            icon: 'pi pi-plus',
            command: () => onOptionChange('criar')
        },
        {
            label: 'Consultar',
            icon: 'pi pi-search',
            items: [
                {
                    label: 'Clientes',
                    icon: 'pi pi-user',
                    command: () => onOptionChange('consultarClientes')
                },
                {
                    label: 'Encomendas por cliente',
                    icon: 'pi pi-shopping-cart',
                    command: () => onOptionChange('consultarEncomendas')
                }
            ]
        }
    ];

    return (
        <div className="p-3">
            <PanelMenu model={items} style={{ width: '100%' }} />
        </div>
    );
};

export default ClientesSidebar;
